export default {"src":"/_next/static/media/logo-1.0095cc8c.svg","height":200,"width":961,"blurWidth":0,"blurHeight":0};